export default "__VITE_ASSET__7783d7c9__"